export var INIT = 0;
export var FETCHING = 1;
export var FETCHED = 2;



// WEBPACK FOOTER //
// ./src/constants/loading.js